<div class="dialog">
  <div class="dialog__header">
    <h1 class="dialog__title">フィー一覧</h1>
    <span class="close" (click)="close()"></span>
  </div>

  <div class="dialog__container">

    <ag-page-scroll-table
      *ngIf="filteredContracts && filteredContracts.length"
      class="table"
      [tableConfig]="tableConfig"
      [content]="filteredContracts"
      [scrollerClass]="'no-scroll'"
    ></ag-page-scroll-table>

    <div class="content" *ngIf="selectedContract">
      <dl>
        <dt>フィー一覧</dt>
        <dd>
          <textarea
            disabled
            cdkTextareaAutosize
            cdkAutosizeMinRows="{{ 2 }}"
            cdkAutosizeMaxRows="{{ 15 }}"
            [value]="selectedContract.dynamicData.feeSummary">
          </textarea>
        </dd>
      </dl>
      <dl>
        <dt>契約備考</dt>
        <dd>
          <textarea
            disabled
            cdkTextareaAutosize
            cdkAutosizeMinRows="{{ 2 }}"
            cdkAutosizeMaxRows="{{ 15 }}"
            [value]="selectedContract.dynamicData.contractRemarks">
          </textarea>
        </dd>
      </dl>
      <dl>
        <dt>入金・その他備考</dt>
        <dd>
          <textarea
            disabled
            cdkTextareaAutosize
            cdkAutosizeMinRows="{{ 2 }}"
            cdkAutosizeMaxRows="{{ 15 }}"
            [value]="selectedContract.dynamicData.paymentRemarks">
          </textarea>
        </dd>
      </dl>
    </div>
  </div>
  <div class="dialog__footer">
    <button
      class="dialog__footer__button btn btn--outline-blue"
      (click)="close()"
    >
      閉じる
    </button>
  </div>
</div>

<ng-template #actions let-data>
  <div class="actions">
    <button
      *ngIf="!selectedContract || data.id !== selectedContract.id"
      class="actions__btn btn btn--small btn--white btn--outline-gray"
      (click)="selectContract(data)"
    >
      表示
    </button>
    <button
      *ngIf="selectedContract && data.id === selectedContract.id"
      class="actions__btn btn btn--small btn--white btn--outline-gray"
      (click)="resetContractSelection()"
    >
      表示解除
    </button>
  </div>
</ng-template>

<ng-template #status let-data>
  <div *ngIf="data.dynamicData.status === '無効'" class="status">
    <div class="status__badge">
      無
    </div>
  </div>
</ng-template>
